// Import styles
import './style.scss';
import './editor.scss';

// Import all blocks
import './blocks/gallery';
import './blocks/related-posts'; 
import './blocks/calculator';
import './blocks/button';
import './blocks/alert';
import './blocks/faq';
import './blocks/faq-item';
import './blocks/table-of-contents';
import './blocks/timeline';
import './blocks/timeline-item';
import './blocks/bibliography';
